var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"box"},[_c('h1',{staticClass:"page-title error--text"},[_vm._v(" "+_vm._s(_vm.localDocumentTitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }